import React from 'react'
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import packageJson from '../../../package.json';
import WohlerLogo from "assets/img/wohler_logo_295x117.png";
import colors from "assets/mavric-theme/base/colors.js";

const { primary, text, white, background } = colors;


const Footer = ({ sidebarOpen, MDrawer }) => {
    const version = packageJson.version != null ? packageJson.version : "";
    return (
        <Box
            component="footer"
            sx={{
                position: "fixed",
                marginLeft: sidebarOpen ? '240px' : '0px', 
                bottom: 0,
                width: "100%",
                left: 0,
                backgroundColor: background.sidenav,
                ...(MDrawer ? {
                    padding: {
                        xs: "8px 16px",
                        sm: "10px 20px"
                    },
                    paddingLeft: {
                        xs: sidebarOpen ? "16px" : "69px",
                        sm: sidebarOpen ? "20px" : "69px"
                    }
                } : {
                    padding: {
                        xs: "8px 16px",
                        sm: "10px 20px"
                    }
                }),
                zIndex: 1,
                transition: 'all 0.3s ease', 
            }}
        >
            <Grid container alignItems="center" spacing={2}>
                <Grid item sm="auto">
                    <Box
                        component="img"
                        sx={{
                            height: { xs: '20px', sm: '24px', md: '28px' },
                            width: 'auto',
                            display: 'block',
                            margin: { xs: '0 auto', sm: '0' }
                        }}
                        alt="Wohler Logo"
                        src={WohlerLogo}
                    />
                </Grid>

                <Grid item sm="auto">
                    <Typography
                        variant="body2"
                        sx={{
                            color: text.main,
                            fontSize: { xs: '12px', sm: '14px' },
                            fontFamily: 'Roboto, sans-serif',
                            textAlign: { xs: 'center', sm: 'left' }
                        }}
                    >
                        © Wohler Technologies {new Date().getFullYear()}
                    </Typography>
                </Grid>

                <Grid item xs="auto" sx={{ display: { sm: 'block' } }}>
                    <Typography
                        variant="body2"
                        sx={{
                            color: text.main,
                            fontSize: '14px',
                            fontFamily: 'Roboto, sans-serif'
                        }}
                    >
                        |
                    </Typography>
                </Grid>

                <Grid item sm="auto">
                    <Typography
                        variant="body2"
                        sx={{
                            color: text.main,
                            fontSize: { xs: '12px', sm: '14px' },
                            fontFamily: 'Roboto, sans-serif',
                            textAlign: { xs: 'center', sm: 'left' }
                        }}
                    >
                        Version: {version}
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    )
}

export default Footer
